import React, {useContext, useEffect, useState} from 'react';
import moment from 'moment';
import {ApplicationContext} from '../context/ApplicationContext';
import {Grid} from '@mui/material';
import {Skeleton} from '@mui/material';
import CardMonthlyReport from '../components/DataCards/CardMonthlyReport';
import CardMonthlyReportSkeleton from '../components/DataCards/CardMonthlyReportSkeleton';
import ComposedChart from '../components/Charts/MonthlyReportsTimeline';
import {getMonthlyReportMany} from '../services/monthlyReport.service';

const MonthlyReportsPage = () => {
    const AppContext = useContext(ApplicationContext);
    const [monthlyReports, setMonthlyReports] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [isAwaitingServer, setIsAwaitingServer] = useState(false);

    useEffect(async () => {
        setIsAwaitingServer(true);
        window.scrollTo(0, 0);
        try {
            const loadedMonthlyReports = await getMonthlyReportMany({column: 'year_and_month', direction: -1});
            const monthlyReportsWithChange = calculateMonthlyGainLoss(loadedMonthlyReports);
            setMonthlyReports(monthlyReportsWithChange);
            setLastUpdated(loadedMonthlyReports && loadedMonthlyReports[0] && loadedMonthlyReports[0].report_date ? loadedMonthlyReports[0].report_date : null)
        } catch (e) {
            AppContext.handleError('Unable to load monthly reports.');
        }
        setIsAwaitingServer(false);
    }, []);

    const calculateMonthlyGainLoss = (monthlyReports) => {
        for (let i = 0; i < monthlyReports.length; i++) {
            try {
                monthlyReports[i].change = monthlyReports[i].net_worth - monthlyReports[i + 1].net_worth;
            } catch {
                monthlyReports[i].change = 0;
            }
        }
        return monthlyReports;
    }

    const generateMonthlyReportCards = () => {
        let monthlyReportCards = [];
        if (isAwaitingServer) {
            for (let i = 0; i < 12; i++) {
                monthlyReportCards.push(<Grid item xs={12} sm={6} md={4} lg={3}>
                    <CardMonthlyReportSkeleton/>
                </Grid>);
            }
        } else {
            for (let i = 0; i < monthlyReports?.length; i++) {
                monthlyReportCards.push(<Grid item xs={12} sm={6} md={4} lg={3} key={monthlyReports[i]._id}>
                    <CardMonthlyReport data={monthlyReports[i]}/>
                </Grid>);
            }
        }
        return monthlyReportCards;
    }

    const MonthlyCardSection = () => {
        if (!monthlyReports || !monthlyReports.length) {
            return (
                <Grid item xs={12}>
                    <div style={{textAlign: 'center', marginTop: '2rem'}}>
                        No monthly reports to show.
                        Monthly reports will appear if sources with entries exist and were created before the current month.
                    </div>
                    <br/>
                </Grid>
            );
        } else {
            return (
                <Grid container spacing={2} style={{marginTop: '0.5rem'}}>
                    {generateMonthlyReportCards()}
                </Grid>
            )
        }
    }

    return (<div className='animated fadeIn'>
        <section>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div className={'primary-font'} style={{display: 'flex', justifyContent: 'right'}}>
                        {isAwaitingServer ? <Skeleton className='skeleton-loader' style={{width: '35%'}}/> :
                            lastUpdated
                                ? <span>Last updated on {moment(lastUpdated).format('LLL')}</span>
                                : null
                            }
                    </div>
                    <br/>
                </Grid>
                <Grid item xs={12} md={8} style={{minHeight: '240px'}}>
                    <div className={'card-bg'} style={{height: '100%', padding: '1rem'}}>
                        {monthlyReports && monthlyReports.length > 0
                            ? <ComposedChart chartData={monthlyReports}/>
                            : <i style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', textAlign: 'center', padding: '1rem'}}>Create sources with entries to see your financial timeline. Monthly reports are generated on a monthly basis.</i>
                        }
                    </div>
                </Grid>
                <Grid item xs={12} md={4}>
                    <div className={'card-bg'} style={{height: '100%', padding: '2rem'}}>
                            <span className='large-label primary-font'>View your wealth by month.</span>
                        <br/>
                        <p className='small-label primary-font'>Compare your financial standing
                            from month to month by viewing historical records of your assets, liabilities, and
                            equity.</p>
                    </div>
                </Grid>
            </Grid>
        </section>
        <MonthlyCardSection/>
    </div>);

};

export default MonthlyReportsPage;
